module.exports = __webpack_public_path__ + "media/images/generator-single-e0de417f08ec695a9e7fa3c6b53d6613.png";